import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
import { type Route } from '@/routes/route';

const { Page } = lazyImport(() => import('../index'), 'Page');
export const routes: Route[] = [
  {
    name: '404',
    path: '*',
    element: <Page />,
    enable: true,
  },
];
